"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _reactRouterRedux = require("react-router-redux");

var _BlogSettingsEmptyStateContainer = _interopRequireDefault(require("./BlogSettingsEmptyStateContainer"));

var _BlogSettingsHeaderContainer = _interopRequireDefault(require("./BlogSettingsHeaderContainer"));

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _Blog = _interopRequireDefault(require("settings-ui-sdk/Blogs/Blog"));

var _actions = require("settings-ui-sdk/Blogs/actions");

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _resetAllChanges = _interopRequireDefault(require("redux-less/actions/resetAllChanges"));

var _RequestStatusTypes = _interopRequireWildcard(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _blogSelectors = require("../selectors/blogSelectors");

var didBlogFromRouteChange = function didBlogFromRouteChange(currentBlog, nextBlog) {
  return nextBlog !== undefined && nextBlog.get('id') !== currentBlog.get('id');
};

var didBlogSuccessfullyUpdate = function didBlogSuccessfullyUpdate(currentRequestStatus, nextRequestStatus) {
  return currentRequestStatus === _RequestStatusTypes.default.PENDING && nextRequestStatus === _RequestStatusTypes.default.SUCCEEDED;
};

var BlogSettingsPageContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BlogSettingsPageContainer, _PureComponent);

  function BlogSettingsPageContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BlogSettingsPageContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogSettingsPageContainer).call(this, props));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BlogSettingsPageContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var blogFromRoute = this.props.blogFromRoute;
      this.props.resetChanges();
      this.props.stageForEdit(blogFromRoute);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var blogs = newProps.blogs,
          blogFromRoute = newProps.blogFromRoute,
          updateBlogRequestStatus = newProps.updateBlogRequestStatus,
          updateAdditionalSettingsRequestStatus = newProps.updateAdditionalSettingsRequestStatus; // Handles if the blog ID is invalid but there are other blogs in the portal

      if (!blogFromRoute && blogs.size > 0) {
        this.props.push('website/blogs');
      }

      if (didBlogFromRouteChange(this.props.blogFromRoute, blogFromRoute) || didBlogSuccessfullyUpdate(this.props.updateBlogRequestStatus, updateBlogRequestStatus) || didBlogSuccessfullyUpdate(this.props.updateAdditionalSettingsRequestStatus, updateAdditionalSettingsRequestStatus)) {
        this.props.stageForEdit(blogFromRoute);
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props = this.props,
          blogForSaving = _this$props.blogForSaving,
          numberOfStagedChanges = _this$props.numberOfStagedChanges,
          numberOfAdditionalStagedChanges = _this$props.numberOfAdditionalStagedChanges;

      if (numberOfStagedChanges > 0) {
        this.props.updateBlog(blogForSaving);
      }

      if (numberOfAdditionalStagedChanges > 0) {
        this.props.updateAdditionalSettings();
      }
    }
  }, {
    key: "getSaveRequestStatus",
    value: function getSaveRequestStatus() {
      var _this$props2 = this.props,
          updateBlogRequestStatus = _this$props2.updateBlogRequestStatus,
          updateAdditionalSettingsRequestStatus = _this$props2.updateAdditionalSettingsRequestStatus;

      if (updateAdditionalSettingsRequestStatus === _RequestStatusTypes.default.PENDING) {
        return updateAdditionalSettingsRequestStatus;
      }

      return updateBlogRequestStatus;
    }
  }, {
    key: "getChangesDescription",
    value: function getChangesDescription() {
      var _this$props3 = this.props,
          changesDescription = _this$props3.changesDescription,
          numberOfStagedChanges = _this$props3.numberOfStagedChanges,
          numberOfAdditionalStagedChanges = _this$props3.numberOfAdditionalStagedChanges;

      if (changesDescription) {
        return changesDescription;
      }

      var totalChanges = numberOfStagedChanges + numberOfAdditionalStagedChanges;
      var langKey = totalChanges === 1 ? 'stagedChange' : 'stagedChanges';
      return _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.blog." + langKey,
        options: {
          numberOfStagedChanges: totalChanges
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          blogFromRoute = _this$props4.blogFromRoute,
          children = _this$props4.children,
          numberOfStagedChanges = _this$props4.numberOfStagedChanges,
          numberOfAdditionalStagedChanges = _this$props4.numberOfAdditionalStagedChanges;

      if (!blogFromRoute) {
        return _react.default.createElement(_BlogSettingsEmptyStateContainer.default, null);
      }

      var totalChanges = numberOfStagedChanges + numberOfAdditionalStagedChanges;
      var showStickySaveBar = totalChanges > 0;
      return _react.default.createElement("div", null, _react.default.createElement(_BlogSettingsHeaderContainer.default, null), children, _react.default.createElement(_SettingsStickySaveFooter.default, {
        saveRequestStatus: this.getSaveRequestStatus(),
        shouldRender: showStickySaveBar,
        description: this.getChangesDescription(),
        onCancel: this.props.resetChanges,
        onSave: this.handleSave
      }));
    }
  }]);
  return BlogSettingsPageContainer;
}(_react.PureComponent);

BlogSettingsPageContainer.defaultProps = {
  numberOfAdditionalStagedChanges: 0,
  updateAdditionalSettingsRequestStatus: _RequestStatusTypes.default.UNINITIALIZED
};
BlogSettingsPageContainer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  changesDescription: _react.PropTypes.string,
  blogFromRoute: _react.PropTypes.instanceOf(_Blog.default),
  blogForSaving: _react.PropTypes.object.isRequired,
  numberOfStagedChanges: _react.PropTypes.number.isRequired,
  resetChanges: _react.PropTypes.func.isRequired,
  stageForEdit: _react.PropTypes.func.isRequired,
  updateBlog: _react.PropTypes.func.isRequired,
  updateBlogRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  updateAdditionalSettings: _react.PropTypes.func,
  updateAdditionalSettingsRequestStatus: _RequestStatusTypes.RequestStatusPropType,
  numberOfAdditionalStagedChanges: _react.PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  blogs: _react.PropTypes.instanceOf(_immutable.Map).isRequired,
  push: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var numberOfStagedChanges = _UpdateBlogSettings.default.isChanged('id')(state) ? 0 : _UpdateBlogSettings.default.numberOfChanges(state);
  return {
    numberOfStagedChanges: numberOfStagedChanges,
    blogs: (0, _selectors.getBlogs)(state),
    blogFromRoute: (0, _selectors.getBlogFromRoute)(state),
    blogForSaving: (0, _blogSelectors.getBlogSettingsForSaving)(state),
    updateBlogRequestStatus: (0, _selectors.getUpdateBlogRequestStatus)(state)
  };
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push,
  updateBlog: _actions.updateBlog,
  resetChanges: _resetAllChanges.default,
  stageForEdit: _UpdateBlogSettings.default.stageForEdit
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BlogSettingsPageContainer);

exports.default = _default;
module.exports = exports.default;